import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Button from 'components/common/Button/Button'
import Media from 'components/common/Media'
import { SCHEDULE_APPOINTMENT, REQUEST_APPOINTMENT } from 'constant'
import { REQUEST_APPOINTMENT_BUTTON } from '../constants'

const StepperActionBar = ({
  currentStepIndex,
  hasPrevPage,
  hasNextPage,
  isPrevPageVisible,
  prevPageClick,
  nextPageClick,
  requestAppointmentClick,
  alignRight,
  isE2EAppointment
}) =>
  <Container alignRight={ alignRight }>
    {isPrevPageVisible &&
      <Button
        data-button="back"
        narrow
        linkArrowLeft={ hasPrevPage }
        data-at-appointment-prev={ `${currentStepIndex + 1}` }
        disabledNoBgArrowLeft={ !hasPrevPage }
        onClick={ prevPageClick }>
        BACK
      </Button>}

    {hasNextPage ?
      <Button
        data-button="next"
        data-at-appointment-next={ `${currentStepIndex + 1}` }
        narrow
        greenBgArrowRight
        type="submit"
        onClick={ nextPageClick }>
        NEXT
      </Button> :
      <Button
        className={ REQUEST_APPOINTMENT_BUTTON }
        data-at-appointment-submit
        data-request-appointment-final
        narrow
        submitGreenBgArrowRight
        onClick={ requestAppointmentClick }>
        { isE2EAppointment ? SCHEDULE_APPOINTMENT : REQUEST_APPOINTMENT }
      </Button>}
  </Container>

export default StepperActionBar

StepperActionBar.propTypes = {
  alignRight: PropTypes.bool,
  currentStepIndex: PropTypes.number,
  hasNextPage: PropTypes.bool,
  hasPrevPage: PropTypes.bool,
  isE2EAppointment: PropTypes.bool,
  isPrevPageVisible: PropTypes.bool,
  nextPageClick: PropTypes.func,
  prevPageClick: PropTypes.func,
  requestAppointmentClick: PropTypes.func
}

const Container = styled.div`
  ${Media.desktop`
    ${props => props.alignRight && css`
      text-align: right;
    `}
  `}
  ${Media.mobile`
    display: flex;
    padding: 0 10px;

    & ${Button} {
      flex: 1;
    }
  `}
`
